// Method to Share User view
import {
  SharedViewStatus,
  UpdateSharedUserViewsInput,
  UserViewPreferences,
} from '@amzn/controllershiphub-typescript-client';
import { apiCall } from 'src/utils/ApiCall';
import { SharedView } from 'src/components/views/ShareView';

export const shareUserView = async (
  controlId: string,
  viewName: string,
  aliases: string,
  description: string,
  viewPreference: UserViewPreferences
): Promise<void> => {
  const input: UpdateSharedUserViewsInput = {
    controlId,
    viewName,
    aliases,
    description,
    viewPreference,
  };
  try {
    await apiCall<void>({
      endpoint: `/chub/v1/controls/${controlId}/view/shared`,
      method: 'PUT',
      body: input,
    });
  } catch (error) {
    console.error('Error in shareUserView:', error);
    throw error;
  }
};

// Method to retrieve Shared User views
export const getSharedUserViews = async (controlId: string): Promise<SharedView[]> => {
  try {
    const response = await apiCall<{ sharedViews: SharedView[] }>({
      endpoint: `/chub/v1/controls/${controlId}/view/shared`,
      method: 'GET',
    });
    return response.sharedViews;
  } catch (error) {
    console.error('Error getting shared views:', error);
    throw error;
  }
};

// Method to update shared user view
export const updateSharedViewStatus = async (params: {
  controlId: string;
  viewId: string;
  status: SharedViewStatus;
}): Promise<void> => {
  try {
    await apiCall<void>({
      endpoint: `/chub/v1/controls/${params.controlId}/view/status`,
      method: 'PUT',
      body: {
        viewId: params.viewId,
        status: params.status,
      },
    });
  } catch (error) {
    console.error('Error updating shared view status:', error);
    throw error;
  }
};
